module.exports = __webpack_public_path__ + "static/media/main_large_5.baf3fe47.png";